/**
 * Sales tab feature flag. Everything new for the Sales tab (nav group, routes,
 * cash-drawer relocation) stays behind this until go-live. Default OFF.
 *
 * Mirrors the `REACT_APP_MED_SPA_FORM_NOTIFICATION` env-flag pattern
 * (components/clients/ClientFormsWaiversTab.tsx). Read at call time so tests can
 * flip `process.env.REACT_APP_SALES_TAB` per case.
 */
export function isSalesTabEnabled(): boolean {
  return process.env.REACT_APP_SALES_TAB === "true";
}
